<div class="row">
  <div class="col-12">
    <h2>My Chains</h2>
  </div>
</div>

<div *ngIf="!loading && chains.length === 0" class="empty-state" style="margin-top: 40px; text-align: center;">
  <nb-card>
    <nb-card-body>
      <nb-icon icon="link-2-outline" style="font-size: 48px; color: #ccc;"></nb-icon>
      <p style="color: #888; margin-top: 16px; font-size: 16px;">No chains have been assigned to your account yet.</p>
    </nb-card-body>
  </nb-card>
</div>

<div *ngFor="let chain of chains" class="col-12" style="margin-top: 20px">
  <nb-card class="chain-card">
    <nb-card-header>
      <div class="chain-header">
        <div>
          <span class="chain-title">{{ chain.chainName }}</span>
          <nb-badge
            [text]="getStatusText(chain.status)"
            [status]="getStatusBadge(chain.status)"
            style="margin-left: 10px"
          ></nb-badge>
          <span class="store-count-badge ms-2">
            {{ chain.storeCount || chain.stores?.length || 0 }} store(s)
          </span>
        </div>
        <div class="chain-actions">
          <button
            type="button"
            class="btn btn-primary btn-sm"
            (click)="viewChainOverview(chain._id)"
          >
            <nb-icon icon="grid-outline"></nb-icon> Overview
          </button>
          <button
            type="button"
            class="btn btn-outline-primary btn-sm ms-2"
            (click)="viewChainReports(chain._id)"
          >
            <nb-icon icon="bar-chart-outline"></nb-icon> View Reports
          </button>
          <button
            type="button"
            class="btn btn-outline-secondary btn-sm ms-2"
            (click)="viewChainBranding(chain._id)"
          >
            <nb-icon icon="color-palette-outline"></nb-icon> Branding
          </button>
          <button
            type="button"
            class="btn btn-outline-info btn-sm ms-2"
            (click)="viewChainCatalog(chain._id)"
          >
            <nb-icon icon="grid-outline"></nb-icon> Catalog
          </button>
          <button
            type="button"
            class="btn btn-outline-success btn-sm ms-2"
            (click)="viewChainLoyalty(chain._id)"
          >
            <nb-icon icon="award-outline"></nb-icon> Loyalty
          </button>
        </div>
      </div>
      <p class="chain-description" *ngIf="chain.description">{{ chain.description }}</p>
    </nb-card-header>
    <nb-card-body>
      <table class="table text-center" *ngIf="chain.stores && chain.stores.length > 0">
        <thead>
          <tr>
            <th>Store Name</th>
            <th>Address</th>
            <th>Status</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let store of chain.stores">
            <td>{{ store.storeName }}</td>
            <td>{{ store.address || '-' }}</td>
            <td>
              <nb-badge
                [text]="getStatusText(store.status)"
                [status]="getStoreStatusBadge(store.status)"
              ></nb-badge>
            </td>
            <td>
              <button
                type="button"
                class="btn btn-primary btn-sm"
                (click)="manageStore(store)"
              >
                Manage Store
              </button>
            </td>
          </tr>
        </tbody>
      </table>
      <div *ngIf="!chain.stores || chain.stores.length === 0" style="text-align: center; color: #888; padding: 20px">
        No stores in this chain.
      </div>
    </nb-card-body>
  </nb-card>
</div>

<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="large" [fullScreen]="true" color="white" type="ball-circus">
  <p style="color: white">Loading...</p>
</ngx-spinner>
